export default function ResumePage() {
  return (
    <div>
      <div className="">ResumePage</div>
    </div>
  );
}
